<template>
  <Select v-model="type" :placeholder="placeholder" @on-change="change_value">
    <Option
      v-for="(item, index) in options"
      :value="item.value"
      :key="`${index}-${item.value}`"
    >
      {{ item.label }}
    </Option>
  </Select>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择仓库"
    },
    data: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      type: "",
      options: [{ value: 0, label: "全部仓库" }]
    };
  },
  watch: {
    data(val) {
      val.map(o => this.options.push({ value: o.id, label: o.name }));
    }
  },
  methods: {
    change_value(val) {
      let params = getParams("b.typeid", val, "=");
      this.$emit("get", params, Boolean(val));
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseWarehouse.vue